import { NavLink } from 'react-router-dom'
import { useLangPathPrefix } from '../hooks/lang'

export default function NavLangLink(props: Parameters<typeof NavLink>[0]) {
  return <NavLink {...props} to={`${useLangPathPrefix()}${props.to}`} />
}
